import { render, staticRenderFns } from "./message-pattern-textarea.vue?vue&type=template&id=45c3319a&scoped=true&"
import script from "./message-pattern-textarea.vue?vue&type=script&lang=js&"
export * from "./message-pattern-textarea.vue?vue&type=script&lang=js&"
import style0 from "./message-pattern-textarea.vue?vue&type=style&index=0&id=45c3319a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c3319a",
  null
  
)

export default component.exports